import { ADOBE_AUDIENCE_MANAGER_CMP } from './ids';
import { logResults, cmpLog, LOG_TYPE_INFO, LOAD_CONSENT, SUCCESS, FAILED } from './logger';
import { saveConsentValue } from './consentUtils';
var DMP_CONSENT_CHANGE_EVENT = 'event150';
var PARTNER = 'DMP'; // Add consent value in context

function updateAdobeConsentData() {
  var aamConsent = window.consents.getConsent(ADOBE_AUDIENCE_MANAGER_CMP);
  var _window = window,
      s = _window.s,
      consents = _window.consents;
  consents.dmp = aamConsent.vendor ? aamConsent.consent : aamConsent;
  saveConsentValue('aamConsentValue', consents.dmp);
  var aam = Number(!window.consents.dmp);

  if (s) {
    logResults('DMP', aam);
    s.contextData['cm.ssf'] = "".concat(aam);
    s.eVar72 = "".concat(aam);
  }

  return aam;
}

export default (function (handleAdobe) {
  return function (tcData, success) {
    cmpLog(LOG_TYPE_INFO, "".concat(LOAD_CONSENT, " [").concat(PARTNER, "]"), success ? SUCCESS : FAILED);

    if (success) {
      var aam = updateAdobeConsentData();

      if (tcData.eventStatus === 'useractioncomplete') {
        var _global = global,
            omniture = _global.omniture_middleware;

        if (omniture) {
          omniture.trackEvent(DMP_CONSENT_CHANGE_EVENT);
        } else if (handleAdobe) {
          handleAdobe(aam);
        }
      }
    }
  };
});